<a routerLink="/{{moduleLink.title}}/dashboard">
    <!-- <div class="gridDiv{{moduleLink.title | shortenNoPoints: 4}} " > -->
    <div class="gridDiv{{moduleLink.title }} ">
        <h1 class="title-mod "><span>{{moduleLink.title}}</span></h1>
        <p class="sub-title-mod "><span>{{moduleLink.subTitle}}</span></p>
    </div>
</a>